if (!customElements.get('wls-pagination')) {
  class WLSPagination extends HTMLElement {
    constructor() {
      super();
      this.onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }


    _onClick(event) {
      const link = event.target.closest('a[data-page]');
      if (!link) return;

      event.preventDefault();

      const url = new URL(window.location.href);
      url.searchParams.set('page', link.dataset.page);

      wlsTriggerEvent(this, 'wls:pagination:page-changed', { url: url.toString() });
    }
  }

  customElements.define('wls-pagination', WLSPagination);
}
